import { useState, useEffect } from 'react';

import audioPlayer from '../AudioPlayer';
import { Icon } from '../../Icon/Icon';
import classes from "./GlobalAudio.module.scss";

interface AudioToggleIconProps {
    isPaused: boolean;
}

function AudioToggleIcon({ isPaused }: AudioToggleIconProps) {
    return <Icon name={isPaused ? 'play' : 'pause'} />;
}

function GlobalAudio() {
    const [isPaused, setIsPaused] = useState(true);

    const toggleAudio = () => {
        const playingAudio = audioPlayer.getPlayingAudio();
        if (!playingAudio?.src) {
            audioPlayer.campaignAudio();
        } else {
            audioPlayer.toggle?.();
        }
    };

    const onMediaPlay = () => {
        setIsPaused(false);
    };

    const onPause = () => {
        setIsPaused(true);
    };

    const onStop = () => {
        setIsPaused(true);
    };

    useEffect(() => {
        audioPlayer.addEventListener('play', onMediaPlay);
        audioPlayer.addEventListener('pause', onPause);
        audioPlayer.addEventListener('stop', onStop);

        return () => {
            audioPlayer.removeEventListener('play', onMediaPlay);
            audioPlayer.removeEventListener('pause', onPause);
            audioPlayer.removeEventListener('stop', onStop);
        };
    }, []);

    return (
        <div className={classes.GlobalAudioWrapper}>
            <button
                onClick={toggleAudio}
                className={classes.AudioToggle}
            >
                <AudioToggleIcon isPaused={isPaused} />
            </button>
        </div>

    );
}

export default GlobalAudio;
